import { AsyncLocalStorageIfNode } from "@megaron/async-local-storage";

export const loggerContext =
  typeof AsyncLocalStorageIfNode !== "undefined" ? new AsyncLocalStorageIfNode<Record<string, unknown>>() : undefined;
export const setLoggerContext = (context: Partial<Record<string, unknown>>) =>
  loggerContext?.enterWith({ ...loggerContext.getStore(), ...context });

export const getCorrelationId = (): string | undefined => {
  const correlationId = loggerContext?.getStore()?.["correlationId"];
  if (correlationId !== undefined && typeof correlationId !== "string") {
    // eslint-disable-next-line no-console
    console.warn("correlationId is not a string");
    return undefined;
  }
  return correlationId;
};
